<template>
  <pt-lab-product-detail class="pt-lab-product-detail__page"></pt-lab-product-detail>
</template>

<script>
import PtLabProductDetail from 'cps/lab-product/pt-lab-product/pt-lab-product-detail/withData'
export default {
  name: 'pt-lab-product-detail__view',
  components: {
    'pt-lab-product-detail': PtLabProductDetail
  }
}
</script>
